import React from "react"; 

// @TODO Make this better. 
const NotFound = () => ( <h1> Page Not Found!</h1> ); 

export default NotFound; 